module.exports = __webpack_public_path__ + "media/images/city_img/h-51a3d042e06834836a51e54a065431b5.jpg";